<template>
  <div class="form-group">
    <label for="investor_offering">Select an Offering:</label>
    <select id="investor_offering" class="form-control" name="investor_offering" required v-model="payload.investor_offering">
      <option disabled="disabled" value="">--Select One--</option>
      <option v-for="option in offeringList" :value="option.id">{{ option.name }}</option>
    </select>
    <label for="investor_amount">Investor Amount (optional)</label>
    <currency-input
      name="investor_amount"
      v-model="payload.investor_amount"
      :allow-negative="false"
      :removecents="false"
      :currency="'$'"
      :distraction-free="false"
      :onInput="handleInvestorAmountInput"
    ></currency-input>
    
    <button type="submit" class="btn btn-primary btn-md center-block margin-top-20" @click.prevent="setOffering" :disabled="disableBtn">Save Offering</button>
    <label v-if="showResMessage">{{ resMessage }}</label>
  </div>
</template>

<script>
import axios from "axios";
import CurrencyInput from "../CurrencyInput.vue";

export default {
  components: {
    CurrencyInput,
  },
  props: {
    offeringList: Array,
    profileData: Object
  },
  data() {
    return {
      payload: {
        investor_offering: '',
        investor_id: 0,
        investor_amount: '',
      },
      offering: {},
      resMessage: '',
      showResMessage: false
    }
  },
  methods: {
    setOffering() {
      this.payload.investor_id = this.profileData.id
      const investor_amount = this.payload.investor_amount
      if (investor_amount && !isNaN(investor_amount) && investor_amount < 0) {
        this.resMessage = 'Please enter amount more than 0'
        this.showResMessage = true
        return
      }
      axios.post('investor/select_offering',this.payload).
        then(response => {
          this.offering = response.data.offering
          this.resMessage = response.data.statusMessage
          this.showResMessage = true
          this.$emit('offering-saved',this.offering)
        return Promise.resolve()
      })
    },
    timer() {
      setTimeout(() => {
        this.showResMessage = false
        this.resMessage = ''
      }, 5000)
    },
    handleInvestorAmountInput(value) {
      this.payload.investor_amount = value;
    }
  },
  computed: {
    disableBtn() {
      return !this.profileData.id
    }
  },
}
</script>